/* eslint-disable */
import {isNotQualified} from '@aoflmkt/is-webp-qualified';

const imageConfig = {
  arrowLeft: [{src: `${isNotQualified ? '/assets/routes/home/arrow-left-v1.png' : '/assets/routes/home/arrow-left-v1.webp'}`}],
  arrowRight: [{src: `${isNotQualified ? '/assets/routes/home/arrow-right-v1.png' : '/assets/routes/home/arrow-right-v1.webp'}`}]
};

export {
  imageConfig
};
